import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TestPicture } from '../dto/test-picture';

@Injectable({
  providedIn: 'root'
})
export class TestPictureService {

  private apiUrl = environment.apiRoot + '/testpicture';
    
  constructor(private http : HttpClient) { }

  getAllPicturesOfTest(testId: number) : Observable<TestPicture[]> {
    return this.http.get<TestPicture[]>(this.apiUrl + '/alloftest?testId=' + testId); 
  }

  getTestPicture(testPictureId: number) : Observable<ArrayBuffer> {
    return this.http.get(this.apiUrl + '/picture?testPictureId=' + testPictureId, {responseType: 'arraybuffer'});
  }
  
  fileUpload(testId: number, file: File): Observable<any> {
    const formData = new FormData();
    formData.append("file", file);
    return this.http.post(this.apiUrl + '/fileupload?testId=' + testId, formData);
  }

  deleteTestPicture(testPictureId: number): Observable<string> {
    return this.http.delete<string>(this.apiUrl + '/delete?testPictureId=' + testPictureId);
  }
}
